import React from "react";

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

const PromotionIcon: React.FC<Props> = (props) => {
  const { width, height, color } = props;
  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 512.003 512.003"
      style={{ enableBackground: "new 0 0 512.003 512.003" } as any}
      width={width}
      height={height}
      fill={color}
    >
      <g>
        <g>
          <path
            d="M493.94,293.239l-18.704-28.744c-3.362-5.157-3.362-11.826,0-16.994l18.713-28.755
     c17.035-26.227,5.507-61.358-23.564-72.468l-32.018-12.267c-5.755-2.204-9.682-7.604-9.999-13.752l-1.762-34.242
     c-1.596-31.135-31.477-52.885-61.665-44.807l-33.106,8.905c-5.929,1.594-12.305-0.457-16.167-5.249l-21.562-26.67
     c-19.624-24.285-56.657-24.245-76.221,0.017l-21.562,26.655c-3.862,4.793-10.227,6.854-16.156,5.249l-33.106-8.899
     c-30.106-8.109-60.076,13.626-61.675,44.801l-1.762,34.248c-0.315,6.147-4.232,11.543-9.987,13.746L41.619,146.27
     c-29.107,11.146-40.598,46.293-23.554,72.5l18.69,28.721c3.362,5.168,3.362,11.848,0.011,17.005l-18.701,28.744
     c-17.036,26.148-5.571,61.359,23.554,72.489l32.018,12.261c5.755,2.208,9.672,7.604,9.987,13.752l1.762,34.248
     c1.596,31.13,31.502,52.893,61.675,44.801l33.106-8.91c5.919-1.589,12.272,0.457,16.167,5.266l21.552,26.655
     c19.585,24.236,56.559,24.298,76.232,0.011l21.552-26.666c3.884-4.808,10.227-6.844,16.156-5.266l33.138,8.921
     c30.051,8.055,60.043-13.594,61.642-44.813l1.762-34.237c0.315-6.157,4.243-11.554,9.999-13.763l32.018-12.25
     C499.483,354.597,510.985,319.446,493.94,293.239z M188.413,165.95c18.43,0,33.421,14.992,33.421,33.421
     c0,18.43-14.992,33.421-33.421,33.421c-18.43,0-33.421-14.992-33.421-33.421C154.992,180.942,169.984,165.95,188.413,165.95z
      M310.958,355.338c-18.43,0-33.421-14.992-33.421-33.421c0-18.43,14.992-33.421,33.421-33.421
     c18.43,0,33.421,14.992,33.421,33.421C344.38,340.347,329.388,355.338,310.958,355.338z M339.485,194.476L183.518,350.442
     c-6.528,6.528-17.102,6.528-23.63,0c-6.527-6.527-6.527-17.103,0-23.63l155.966-155.966c6.527-6.527,17.103-6.527,23.63,0
     C346.012,177.373,346.012,187.948,339.485,194.476z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default PromotionIcon;
